import { Config } from "../core/config/config.js";
import { Helper } from "../core/util/helper.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import React from "react";
interface SmartSearchAutoCompleteProps {
    disabled?: boolean,
    initialValues?: SmartSearchAPiCompletitionResult[],
    initialSearchText?: string,
    onSelectionChanged: () => void,
    autoClose?: boolean
}

export class SmartSearchAutoComplete extends React.Component<SmartSearchAutoCompleteProps, any>{
    private multiSelectRef: HTMLSelectElement;
    private multiSelect: kendo.ui.MultiSelect;
    private selectedItems: SmartSearchAPiCompletitionResult[] = [];

    constructor(props: SmartSearchAutoCompleteProps) {
        super(props)
        if (props.initialValues && props.initialValues.length) {
            this.selectedItems = props.initialValues;
        }
    }

    getSelected = (): SmartSearchAPiCompletitionResult[] => {
        return this.selectedItems ?? [];
    }

    highlightText = (text, indices) => {
        if (!indices) {
            return text;
        }

        indices.sort((a, b) => a - b);
        let result = "";
        let currentIndex = 0;

        for (let i = 0; i < indices.length; i += 2) {
            let start = indices[i];
            let end = indices[i + 1];
            if (currentIndex != start) {
                result += "<pre>" + text.slice(currentIndex, start) + "</pre>";
            }
            result += "<pre style='font-weight:bold;white-space:pre'>" + text.slice(start, end) + "</pre>";
            currentIndex = end;
        }
        result += "<pre>" + text.slice(currentIndex) + "</pre>";

        return result;
    }

    private getTemplate = (item: SmartSearchAPiCompletitionResult) => {
        let additionalInfo = '';
        const text = item.Text || item.ConceptURI;
        const conceptName = item.ConceptName;

        let typeText = Helper.getTranslation(`SmartSearch.SearchType.${item.Type.toLowerCase()}`)
        const getGroupingKey = (obj) => {
            return (obj.Type + "_" + obj.ConceptName + "_" + text).toLowerCase();
        }
        if (this.multiSelect) {
            const items = this.multiSelect.dataSource.data().map((i) => i);
            const groupedItems = Helper.groupBy(items, getGroupingKey);
            if (groupedItems.get(getGroupingKey(item)).length > 1) {
                additionalInfo = item.ConceptURI?.split('#').pop().split('_').slice(1).join('');
            }
        }
        if (Helper.isNullOrEmpty(typeText)) {
            console.log(item.Type)
            typeText = item.Type;
        }
        return `<div style="display: flex; flex-wrap: wrap;align-items:baseline;min-width: 142px;line-height:1.3">
                    <div style="font-weight:bold;">${typeText ? '(' + typeText + ')' : ''}</div>
                    <div style="padding-left: 3px;display:flex;white-space:pre;flex-wrap:wrap;text-wrap:wrap;word-break:break-word">${conceptName ?? ""}</div>
                    <div style="padding-left: 3px; font-style: italic;display:flex;white-space:pre;flex-wrap:wrap;text-wrap:wrap;word-break:break-word">${text == conceptName ? "" : text ?? ""}</div>
                    <div style="font-size:11px;color:gray;margin-left:2px">${additionalInfo}</div> 
                </div>`;
    }

    private getTemplateWithHighlight = (item: SmartSearchAPiCompletitionResult) => {
        let additionalInfo = '';
        const text = item.Text || item.ConceptURI;
        const conceptName = item.ConceptName;

        let typeText = Helper.getTranslation(`SmartSearch.SearchType.${item.Type.toLowerCase()}`)
        const getGroupingKey = (obj) => {
            return (obj.Type + "_" + obj.ConceptName + "_" + text).toLowerCase();
        }
        if (this.multiSelect) {
            const items = this.multiSelect.dataSource.data().map((i) => i);
            const groupedItems = Helper.groupBy(items, getGroupingKey);
            if (groupedItems.get(getGroupingKey(item)).length > 1) {
                additionalInfo = item.ConceptURI?.split('#').pop().split('_').slice(1).join('');
            }
        }
        if (Helper.isNullOrEmpty(typeText)) {
            console.log(item.Type)
            typeText = item.Type;
        }
        return `<div style="display: flex; flex-wrap: wrap;align-items:baseline">
                    <div style="font-weight:bold;">${typeText ? '(' + typeText + ')' : ''}</div>
                    <div style="padding-left: 3px;display:flex;white-space:pre;flex-wrap:wrap">${(conceptName == text ? this.highlightText(conceptName, item.Highlights) : conceptName) ?? ""}</div>
                    <div style="padding-left: 3px; font-style: italic;display:flex;white-space:pre;flex-wrap:wrap">${text == conceptName ? "" : this.highlightText(text, item.Highlights) ?? ""}</div>
                    <div style="font-size:11px;color:gray;margin-left:2px">${additionalInfo}</div> 
                </div>`;
    }

    componentDidMount() {
        let values = [];
        if (this.props.initialValues) {
            values = this.props.initialValues.map(i => i.ConceptURI);
        }
        let isInitialRequest = true;
        this.multiSelect = $(this.multiSelectRef).kendoMultiSelect({
            delay: 500,
            enable: !this.props.disabled,
            height: 450,
            dataTextField: "Type",
            dataValueField: "ConceptURI",
            filter: "contains",
            tagTemplate: this.getTemplate,
            itemTemplate: this.getTemplateWithHighlight,
            value: values,
            autoClose: this.props.autoClose ?? true,
            highlightFirst: true,
            popup: {
                origin: "bottom left",
                position: "top left"
            },
            change: (e) => {
                this.selectedItems = this.multiSelect.dataItems().slice();
                this.props.onSelectionChanged();
            },
            dataSource: {
                type: "json",
                serverFiltering: true,
                transport: {
                    read: async (e) => {
                        if (isInitialRequest) {
                            if (this.props.initialSearchText) {
                                const result = await this.search(this.props.initialSearchText);

                                e.success(result ?? []);
                            }
                            else {
                                e.success(this.selectedItems);
                            }
                            isInitialRequest = false;
                        }
                        else {
                            const searchValue = $(this.multiSelectRef).data("kendoMultiSelect").input.val();
                            const result = await this.search(searchValue);
                            e.success(result ?? []);
                        }
                    }
                },
                schema: {
                    type: "json",
                    model: {
                        fields: {
                            ConceptURI: { field: "ConceptURI", type: "string" },
                            Type: { field: "Type", type: "string" },
                            Text: { field: "Text", type: "string" }
                        }
                    }
                }
            }
        }).data("kendoMultiSelect");
        this.multiSelect.input.val(this.props.initialSearchText);
        this.multiSelect.list.width("500px");
        if (this.props.initialSearchText) {
            this.multiSelect.toggle();
        }

    }

    private search = async (searchValue: string | number | string[]) => {
        try {
            const result = await fetch(`${Config.baseUrl}SmartSearchPreview/Complete?search=${searchValue}`);
            const resultData = await result.json();
            return resultData;
        } catch (e) {
            NotificationHelper.showErrorMessage(Helper.getTranslation("WebSMS.Common.NotConnected"));
            return null;
        }
    }

    render() {
        let style: React.CSSProperties = {
            width: "100%"
        };
        return (
            <div style={{ width: "100%" }}>
                <select ref={(ref) => this.multiSelectRef = ref} style={style}>
                </select>
            </div>
        );
    }
}

